import type { RouteRecordRaw } from 'vue-router';

export const cTEMAS_ROUTES = {
  home: {
    path: '',
    name: 'Temas',
    component: () => import('@/modules/temas/Temas.vue'),
    meta: {
      requiresAuth: true,
    },
  },
};

export const temasRoutes: Array<RouteRecordRaw> = [
  {
    path: cTEMAS_ROUTES.home.path,
    name: cTEMAS_ROUTES.home.name,
    component: cTEMAS_ROUTES.home.component,
    meta: {
      requiresAuth: cTEMAS_ROUTES.home.meta.requiresAuth,
    },
  },
];
